<template>
  <div class="Auth">
    <auth-page />
  </div>
</template>

<script>
// @ is an alias to /src
import AuthPage from '@/components/AuthPage.vue';
 

export default {
  name: 'AuthPageView',
  components: {
    AuthPage
  }
}
</script>
